var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"case_item",attrs:{"cols":"12","md":"4"}},[_c('router-link',{attrs:{"to":"/case_power_radlab"}},[_c('b-img',{attrs:{"src":require("../assets/client_tpcrl.png"),"fluid":"","alt":"Responsive image"}}),_c('p',{staticClass:"caseUnit_name"},[_vm._v("台電放射試驗室")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }